export const getUrl: () => string = () => {
  return process.env.NODE_ENV === "production"
    ? "https://app.digicust.com"
    : "https://staging.digicust.com";
};

export async function asyncForEach(array: Array<any>, callback: Function) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export async function asyncMap(array: Array<any>, callback: Function) {
  return Promise.all(array.map(item => callback(item)));
}
